import script from "./GuessCity.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuessCity.vue?vue&type=script&setup=true&lang=ts"

import "./GuessCity.vue?vue&type=style&index=0&id=1d788d8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d788d8d"]])

export default __exports__